import React from "react"
import { RouteComponentProps } from "react-router"
import { Auth } from "../../../Components/Views/Auth/Auth"
import { AuthFormView } from "../../../Models/Client/AuthFormView"
import { decodeAuthParams } from "./SigninRoute"

export function VerifyOTPRoute({ location }: RouteComponentProps) {
    return (
        <Auth
            type={AuthFormView.verify_otp}
            squashSuccessMessage={false}
            {...decodeAuthParams(new URLSearchParams(location.search))}
        />
    )
}
